import './Loader.css';

// Animated "ElecSolution" wordmark — flowing gradient + glow + loading bar.
function Wordmark({ size = 'md', withBar = true }) {
    return (
        <div className={`es-wm es-wm-${size}`} aria-hidden="true">
            <div className="es-wm-text">
                <span className="es-wm-elec">Elec</span><span className="es-wm-sol">Solution</span>
            </div>
            {withBar && <span className="es-wm-bar" />}
        </div>
    );
}

function Loader({
    fullscreen = false,
    overlay = false,
    inline = false,
    size = 'md',
    label = 'Loading',
    // legacy props (showBrand / logo) are accepted but ignored.
}) {
    if (inline) {
        return (
            <span className={`es-loader-inline es-loader-size-${size}`} role="status" aria-label={label}>
                <span className="es-loader-inline-spinner" />
                {label && <span className="es-loader-inline-label">{label}</span>}
            </span>
        );
    }

    const wrapperClass = [
        'es-loader',
        fullscreen ? 'es-loader-fullscreen' : '',
        overlay ? 'es-loader-overlay' : '',
        !fullscreen && !overlay ? 'es-loader-block' : '',
        `es-loader-size-${size}`,
    ].filter(Boolean).join(' ');

    return (
        <div className={wrapperClass} role="status" aria-live="polite" aria-label={label}>
            <Wordmark size={fullscreen ? 'lg' : size} withBar={fullscreen || overlay} />
        </div>
    );
}

export default Loader;
